/**
 * Zasięg agregatu `Σ` przy wierszu drzewka (decyzja 171).
 *
 * ⭐⭐ To NIE jest ustawienie dokładności, tylko wybór PYTANIA. Dwa zasięgi odpowiadają na
 * dwie różne rzeczy i żadna nie jest przybliżeniem drugiej:
 *
 * - `branch` — „ile roboty kryje się pod zwiniętą gałęzią", czyli uzasadnienie decyzji 75:
 *   zwinięty moduł z czterdziestoma zadaniami w środku ma nie wyglądać jak pusty.
 * - `near`  — „ile roboty jest blisko mnie", czyli to, co widzę albo zaraz zobaczę.
 *
 * ⛔ Dlatego zawężenia nie wolno wprowadzić po cichu jako oszczędności: zmierzone 2026-09-05
 * na tenancie `dev` — suma do jednego poziomu obejmuje **8,9 %** roboty w gałęzi, bo robota
 * wisi na liściach. Ta sama liczba jest argumentem ZA przełącznikiem i PRZECIW zamianie
 * domyślnego zasięgu na płytki.
 */
export type SumsScope = 'branch' | 'near';

/**
 * Ile poziomów w dół obejmuje zasięg `near`, licząc sam element jako zerowy.
 *
 * ⭐ Stała mieszka tutaj, a nie w tekście podpowiedzi, bo na niej **stoi zachowanie**
 * (jedzie do API jako `depth`) — a komunikat ma ją czytać z tego samego miejsca, z którego
 * czyta ją program (decyzja 96). Cyfra wpisana w tłumaczenie rozjechałaby się przy pierwszej
 * zmianie zasięgu i nikt by tego nie zauważył.
 */
export const NEAR_SUMS_DEPTH = 2;

/** Zasięg z adresu; nieznana wartość znaczy domyślny, a nie błąd (spec 4A). */
export function readSumsScope(raw: string | null): SumsScope {
  return raw === 'near' ? 'near' : 'branch';
}

/**
 * Zasięg zamieniony na parametr żądania.
 *
 * ⛔⛔ `branch` daje `undefined`, czyli **brak pola** — i to jest jedyny dopuszczalny sposób
 * poproszenia o całą gałąź. Wysłanie tu sufitu serwera (`HasMaxDepth`) znaczyłoby trzymanie
 * na froncie **kopii reguły, która stoi po stronie serwera** — dokładnie ta klasa błędu, którą
 * zamknęła decyzja 153 (`MIN_PASSWORD_LENGTH = 8` przy serwerze wymagającym dziesięciu:
 * kopia rozjechała się cicho i wyszła dopiero u klienta).
 */
export function sumsDepth(scope: SumsScope): number | undefined {
  return scope === 'near' ? NEAR_SUMS_DEPTH : undefined;
}
